import { ThemeUIStyleObject } from "theme-ui";

export const HeroStyle: ThemeUIStyleObject = {
  height: "100svh",
  maxHeight: ["calc(100svh - 15px)", "calc(100svh - 30px)"],
  overflow: "hidden",
  position: "relative",
  backgroundColor: "darkGreen",
  "@media screen and (max-height: 40.0rem) and (orientation: landscape)": {
    height: "150vh",
  },
};

export const HeroContentStyle: ThemeUIStyleObject = {
  position: "absolute",
  height: "200svh",
  maxHeight: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  textAlign: "center",
};

export const contentContainerStyles: ThemeUIStyleObject = {
  display: "flex",
  flexDirection: "column",
};

export const headingStyles: ThemeUIStyleObject = {
  fontSize: ["h2", "h2", "h1"],
  mb: 0,
};

export const descriptionStyles: ThemeUIStyleObject = {
  fontSize: ["paragraphMedium", "paragraphMedium", "paragraphLarge"],
  letterSpacing: "1px",
  fontFamily: "heading",
  maxWidth: "700px",
  margin: "0 auto",
  mt: [8, 10, 11],
};

export const scrollDownWrapStyles: ThemeUIStyleObject = {
  position: "absolute",
  bottom: [4, 4, 11],
  margin: "0 auto",
  width: "100%",
  textAlign: "center",
  left: 0,
};

export const scrollDownStyles: ThemeUIStyleObject = {
  display: "inline-flex",
  flexDirection: "column",
  color: "white",
  cursor: "pointer",
  fontFamily: "heading",
  fontSize: "xsText",
  letterSpacing: "3px",
};

export const scrollDownArrowStyles: ThemeUIStyleObject = {
  "& svg": {
    width: "13px",
    height: "24px",
    mx: "auto",
    "& path": {
      stroke: "white",
    },
  },
};
